import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { Observable, combineLatest, map } from 'rxjs';
import { LoanCardComponent } from '../loan-card/loan-card.component';
import { LoanCard } from '../../../models/loan.model';
import { LoanService } from '../../../services/loan.service';
import { inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/**
 * Component that displays a list of loan cards
 */
@Component({
  selector: 'app-loan-list',
  templateUrl: './loan-list.component.html',
  styleUrl: './loan-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    MatDividerModule,
    MatIconModule,
    LoanCardComponent
  ]
})
export class LoanListComponent {
  #loanService = inject(LoanService);
  #route = inject(ActivatedRoute);
  readonly loans$: Observable<LoanCard[]>;

  constructor() {
    // Combine route params with loans data
    this.loans$ = combineLatest([
      this.#loanService.getLoans(),
      this.#route.params
    ]).pipe(
      map(([loans, params]) => {
        const selectedId = Number(params['id']);
        return loans.map(loan => ({
          ...loan,
          isSelected: loan.id === selectedId
        }));
      })
    );
  }
}
